"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_4.ts
const product_types_1 = require("../types/product.types");
const products = [
    // Curs Presencial Proves Físiques Policia Local Castelldefels 2025 - Sessions
    {
        id: 703,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Sports],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.proves-fisiques-pol-castelldefels-12-abril-1130-1330",
        title: "Entrenament Específic Castelldefels 12/04/25 11:30 - 13:30 h",
        name: "Entrenament Específic Castelldefels 12/04/25 11:30 - 13:30 h",
        short: "1.) Entrenament Específic Castelldefels 12/04/25 11:30 - 13:30 h",
        description: "Supera les proves físiques amb confiança i seguretat",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides",
        price: 19.99,
        // offer: 89.99,
        // offer_text: "Oferta especial les primeres 10 matrícules!",
        shipment: 0.0,
        images: ["/702/image1"],
        banner: ["/702/image1"],
        created_at: "2025-04-03 00:00:01",
        start_at: "2025-04-03 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 702,
        limit: 40,
    },
    // Curs Presencial Proves Físiques Policia Local Castelldefels 2025 - Sessions
    {
        id: 704,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Sports],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.proves-fisiques-pol-castelldefels-19-abril-13-15",
        title: "Entrenament Específic Castelldefels 19/04/25 13:00 - 15:00 h",
        name: "Entrenament Específic Castelldefels 19/04/25 13:00 - 15:00 h",
        short: "2.) Entrenament Específic Castelldefels 19/04/25 13:00 - 15:00 h",
        description: "Supera les proves físiques amb confiança i seguretat",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides",
        price: 19.99,
        // offer: 89.99,
        // offer_text: "Oferta especial les primeres 10 matrícules!",
        shipment: 0.0,
        images: ["/702/image1"],
        banner: ["/702/image1"],
        created_at: "2025-04-03 00:00:01",
        start_at: "2025-04-03 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 702,
        limit: 40,
    },
    // Curs Presencial Entrevista Grupal RolePlay Policia Local 2025
    {
        id: 705,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL, product_types_1.Category.Interviews],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.entrevista-grupal-roleplay-pl-2025-20-abril-09-14",
        title: "Entrevista Grupal RolePlay Policia Local 2025",
        name: "Entrevista Grupal RolePlay Policia Local ",
        description: "🎭 Domina la prova més imprevisible de l'entrevista: entrena el role play amb experts i guanya confiança per destacar davant el tribunal.",
        enabled: false,
        stock: false,
        stock_message: "Pròximament disponible",
        price: 89.99,
        shipment: 0.0,
        images: ["/705/image2"],
        banner: ["/705/image2"],
        link: "/tienda/cursos/entrevista-grupal-roleplay-policia-local-20-abril-2025/",
        created_at: "2025-04-03 00:00:01",
        start_at: "2025-04-03 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
    },
    // Curs Online Policia Local Santa Coloma de Gramenet 2025
    {
        id: 706,
        tax: 0.21,
        sku: "iopos.course.online.open-016-curs-online-policia-local-st-colomona-gramenet-2025",
        title: "Curs Online Policia Local Santa Coloma de Gramenet 2025",
        name: "Curs Online Policia Local Santa Coloma de Gramenet 2025",
        description: "Prepara't amb el campus online més complet i flexible: accés il·limitat, contingut en creixement i les millors notes com a resultat. Inscriu-t'hi avui!",
        category: [product_types_1.Category.PL, product_types_1.Category.Online],
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        offer: 89.99,
        offer_message: "Últim sprint!",
        // offer_text: "Oferta de llançament les 10 primeres matrícules!",
        shipment: 0.0,
        images: ["/706/image1"],
        banner: ["/706/image1"],
        link: "/tienda/cursos/curs-online-policia-local-santa-coloma-gramenet-2025",
        created_at: "2025-04-08 00:00:00",
        start_at: "2022-04-08 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 87, group_id: [2174] },
        can_be_sent: false,
        items: 1,
    },
    // Nous Cursos Online Psicotècnics 2025 + Sessió via Zoom
    {
        id: 707,
        tax: 0.21,
        sku: "iopos.course.online.test-oficial-competencial-online-2026-zoom",
        title: "Test Oficial Competencial Online 2026 + 30 min via Zoom",
        name: "Test Oficial Competencial Online 2026 + 30 min via Zoom",
        description: "Coneix el teu perfil competencial i prepara't per destacar a les oposicions de policia.",
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        shipment: 0.0,
        images: ["/707/image2"],
        banner: ["/707/image2"],
        link: "/tienda/cursos/test-oficial-competencial-online-2026",
        created_at: "2025-04-15 00:00:00",
        start_at: "2025-04-15 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        notify_emails: ["testpsicos@iopos.academy"],
    },
    // Nous Cursos Online Psicotècnics 2025 + Sessió via Zoom
    {
        id: 708,
        tax: 0.21,
        sku: "iopos.course.online.test-oficial-personalitat-online-2026-zoom",
        title: "Test Oficial Personalitat Online 2026 + 30 min via Zoom",
        name: "Test Oficial Personalitat Online 2026 + 30 min via Zoom",
        description: "Conexi millor el teu perfil i estils de comportament",
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        shipment: 0.0,
        images: ["/708/image2"],
        banner: ["/708/image2"],
        link: "/tienda/cursos/test-oficial-personalitat-online-2026",
        created_at: "2025-04-15 00:00:00",
        start_at: "2025-04-15 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        notify_emails: ["testpsicos@iopos.academy"],
    },
    // Nous Cursos Online Psicotècnics 2025 + Sessió via Zoom
    {
        id: 709,
        tax: 0.21,
        sku: "iopos.course.online.test-oficial-clinici-online-2026-zoom",
        title: "Test Oficial Clínic Online 2026 + 30 min via Zoom",
        name: "Test Oficial Clínic Online 2026 + 30 min via Zoom",
        description: "Descobreix aspectes clau del teu benestar emocional i mental.",
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        shipment: 0.0,
        images: ["/709/image2"],
        banner: ["/709/image2"],
        link: "/tienda/cursos/test-oficial-clinic-online-2025",
        created_at: "2025-04-15 00:00:00",
        start_at: "2025-04-15 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        notify_emails: ["testpsicos@iopos.academy"],
    },
    // Formació Exprés Biodata (25 d'abril 18:00 - 20:00 h)
    {
        id: 710,
        tax: 0.21,
        sku: "iopos.course.online.formacio-expres-biodata-online-2025-25-abril",
        title: "Formació Exprés Biodata (25 d'abril 18:00 - 20:00 h)",
        name: "Formació Exprés Biodata (25 d'abril 18:00 - 20:00 h)",
        description: "Tot el que necessites saber abans d'entregar el teu biodata, en una sola sessió.",
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.Online,
            product_types_1.Category.Mossos,
            product_types_1.Category.FASE1,
        ],
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 14.99,
        shipment: 0.0,
        images: ["/710/image1"],
        banner: ["/710/image1"],
        link: "/tienda/cursos/formacio-express-biodata-25-dabril-2025",
        created_at: "2025-04-23 00:00:00",
        start_at: "2025-04-23 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Simulacre Duo 2025 (31 de maig 2025)
    {
        id: 711,
        tax: 0.0,
        hidden: true,
        sku: "iopos.course.f2f.simulacre-duo-2025-31-maig",
        title: "Simulacre Duo 2025 (31 de maig 2025)",
        name: "Simulacre Duo 2025 (31 de maig 2025)",
        description: "Reserva ja el teu Simulacre Duo!",
        category: [product_types_1.Category.Interviews, product_types_1.Category.Mossos],
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 149.99,
        shipment: 0.0,
        images: ["/711/image1"],
        banner: ["/711/image1"],
        link: "/tienda/cursos/simulacre-duo-2025-31-maig/",
        created_at: "2025-05-01 00:00:00",
        start_at: "2025-05-01 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Nous Cursos Online Psicotècnics 2025 + Sessió via Zoom
    {
        id: 713,
        tax: 0.21,
        sku: "iopos.course.online.test-neopir-grafica-personalitzada-30-min-zoom-2025",
        title: "Test NEOPIR amb gràfica personalitzada + 30 min via ZOOM",
        name: "Test NEOPIR amb gràfica personalitzada + 30 min via ZOOM",
        description: "Avalua cinc grans dimensions de la personalitat (model dels Big Five): neuroticisme, extraversió, obertura mental, amabilitat i responsabilitat.",
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        enabled: true,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 99.99,
        shipment: 0.0,
        images: ["/713/image1"],
        banner: ["/713/image1"],
        link: "/tienda/cursos/test-neopir-2025",
        created_at: "2025-05-03 00:00:00",
        start_at: "2025-05-03 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        notify_emails: ["testpsicos@iopos.academy"],
    },
    // Simulacre Duo d'Entrevista (Agent CME i Psicòloga) - Edició Exclusiva
    {
        id: 714,
        tax: 0.0,
        sku: "iopos.course.f2f.simulacre-duo-2025-ed-exclusiva",
        title: "Simulacre Duo d'Entrevista (Agent CME i Psicòloga)",
        name: "Simulacre Duo d'Entrevista (Agent CME i Psicòloga)",
        description: "Reserva ja el teu Simulacre Duo!",
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.Mossos,
            product_types_1.Category.FASE4,
            product_types_1.Category.FaceToFace,
        ],
        special_buy: "/tienda/cursos/simulacre-duo-dentrevista-edicio-exclusiva/#disponibles",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 149.99,
        shipment: 0.0,
        images: ["/714/image1"],
        banner: ["/714/image1"],
        link: "/tienda/cursos/simulacre-duo-dentrevista-edicio-exclusiva/",
        created_at: "2025-05-05 00:00:00",
        start_at: "2025-05-05 00:00:00",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
    },
    // Curs Dret Penal i Processal en directe (11 maig 2025 - 9 a 14)
    {
        id: 715,
        tax: 0.21,
        sku: "iopos.course.online.curs-dret-penal-2025-11-maig-5-hores",
        title: "Curs Dret Penal i Processal en directe (11 maig 2025 - 9 a 14)",
        name: "Curs Dret Penal i Processal en directe (11 maig 2025 - 9 a 14)",
        description: "Prepara't per dominar l'assignatura 5.1 del Codi Penal i assegurar la teva plaça als Mossos!",
        category: [product_types_1.Category.Online, product_types_1.Category.ISPC],
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/715/image1"],
        banner: ["/715/image1"],
        link: "/tienda/cursos/curs-dret-penal-processal-online-11-maig-9-14/",
        created_at: "2025-05-05 00:00:00",
        start_at: "2025-05-05 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 489, group_id: [2229] },
    },
    // Curs Grupal Preparació per l'Entrevista de Competències (24 maig 2025)
    {
        id: 716,
        tax: 0.0,
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.FASE1,
        ],
        sku: "iopos.course.f2f.curs-grupal-preparacio-entrevista-competencies-24-maig-2025",
        title: "Curs Grupal Preparació per l'Entrevista de Competències (24 maig 2025)",
        name: "Curs Grupal Preparació per l'Entrevista de Competències (24 maig 2025)",
        description: "Domina la prova més imprevisible de l'entrevista: entrena el role play amb experts i guanya confiança per destacar davant el tribunal.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/716/image2"],
        banner: ["/716/image2"],
        link: "/tienda/cursos/curs-grupal-preparacio-entrevista-competencies-24-maig-2025/",
        created_at: "2025-05-06 00:00:01",
        start_at: "2025-05-06 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 20,
    },
    // Curso Policial de Tacógrafo. Normativa y actuación operativa
    {
        id: 717,
        tax: 0.0,
        sku: "iopos.course.online.curso-policial-tacografo-2025",
        title: "Curs Policial de Tacògraf. Normativa i actuació operativa",
        name: "Curs Policial de Tacògraf. Normativa i actuació operativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació tècnica especialitzada orientada a garantir una correcta aplicació normativa i operativa del tacògraf en el transport per carretera, amb plena seguretat jurídica en les actuacions policials.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/717/image4"],
        banner: ["/717/image4"],
        link: "/tienda/cursos/formacion-policial/curso-policial-tacografo-2026/",
        created_at: "2025-01-10 00:00:01",
        start_at: "2025-01-10 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [718, 719],
        multiple_languages: false,
    },
    // Curso Policial de Tacógrafo. Normativa y actuación operativa - Idiomas
    {
        id: 718,
        tax: 0.0,
        sku: "iopos.course.online.curso-policial-tacografo-2026-es",
        title: "Curso Policial de Tacógrafo. Normativa y actuación operativa",
        name: "Curso Policial de Tacógrafo. Normativa y actuación operativa",
        short: "1.) Tacógrafo. Normativa y actuación operativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Inspecciona, detecta y actúa: el curso esencial para el control policial del tacógrafo.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/717/image3"],
        banner: ["/717/image3"],
        link: "/tienda/cursos/formacion-policial/curso-policial-tacografo-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        default_in_parent: true,
        multiple_languages: false,
        parent: 717,
        evolmind: { course_id: 546, group_id: [2232] },
    },
    // Curs Policial de Tacògraf. Normativa i actuació operativa - Idiomes
    {
        id: 719,
        tax: 0.0,
        sku: "iopos.course.online.curso-policial-tacografo-2026-ca",
        title: "Curs Policial de Tacògraf. Normativa i actuació operativa",
        name: "Curs Policial de Tacògraf. Normativa i actuació operativa",
        short: "1.) Tacògraf. Normativa i actuació operativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Inspecciona, detecta y actúa: el curso esencial para el control policial del tacógrafo.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/717/image3"],
        banner: ["/717/image3"],
        link: "/tienda/curso/formacio-policial/curso-policial-tacografo-2026/",
        created_at: "2025-05-12 00:00:00",
        start_at: "2025-05-12 00:00:00",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        default_in_parent: false,
        parent: 717,
        multiple_languages: false,
        evolmind: { course_id: 543, group_id: [2235] },
    },
    // Curso de Apoyo Emocional en Accidentes de Tráfico
    {
        id: 720,
        tax: 0.0,
        sku: "iopos.course.online.curso-curso-apoyo-emocional-accidentes-trafico",
        title: "Curs de Suport Emocional en Accidents de Trànsit",
        name: "Curs de Suport Emocional en Accidents de Trànsit",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals policials en la gestió emocional i el suport psicosocial en intervencions per accidents de trànsit, amb criteri tècnic, empatia i coordinació multidisciplinària.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/720/image4"],
        banner: ["/720/image4"],
        link: "/tienda/cursos/formacion-policial/curso-de-apoyo-emocional-en-accidentes-de-trafico-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [721, 722],
        multiple_languages: false,
    },
    // Curso de Apoyo Emocional en Accidentes de Tráfico - Idiomas
    {
        id: 721,
        tax: 0.0,
        sku: "iopos.course.online.curso-curso-apoyo-emocional-accidentes-trafico-es",
        title: "Curso de Apoyo Emocional en Accidentes de Tráfico",
        name: "Curso de Apoyo Emocional en Accidentes de Tráfico",
        short: "1.) Apoyo Emocional en Accidentes de Tráfico",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "Conviértete en un referente en apoyo emocional tras un accidente. Un curso esencial para actuar con empatía y profesionalidad.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/720/image3"],
        banner: ["/720/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-apoyo-emocional-en-accidentes-de-trafico-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        default_in_parent: true,
        parent: 720,
        evolmind: { course_id: 549, group_id: [2238] },
    },
    // Curs de Suport Emocional en Accidents de Trànsit - Idiomes
    {
        id: 722,
        tax: 0.0,
        sku: "iopos.course.online.curso-curso-apoyo-emocional-accidentes-trafico-ca",
        title: "Curs de Suport Emocional en Accidents de Trànsit",
        name: "Curs de Suport Emocional en Accidents de Trànsit",
        short: "1.) Suport Emocional en Accidents de Trànsit",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
        ],
        description: "Conviértete en un referente en apoyo emocional tras un accidente. Un curso esencial para actuar con empatía y profesionalidad.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/720/image3"],
        banner: ["/720/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-apoyo-emocional-en-accidentes-de-trafico-2026/",
        created_at: "2025-05-12 00:00:00",
        start_at: "2025-05-12 00:00:00",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        default_in_parent: false,
        parent: 720,
        evolmind: { course_id: 552, group_id: [2241] },
    },
    // Curso de Reanimación Cardiopulmonar (RCP) y DEA
    {
        id: 723,
        tax: 0.0,
        sku: "iopos.course.online.curso-reanimacion-cardiopulmonar-rcp-y-dea-2026",
        title: "Curs de Reanimació Cardiopulmonar (RCP) i DEA",
        name: "Curs de Reanimació Cardiopulmonar (RCP) i DEA",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals com a primers intervinents davant d’una aturada cardiorespiratòria, amb seguretat, criteri i responsabilitat.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/723/image1"],
        banner: ["/723/image1"],
        link: "/tienda/cursos/formacion-policial/curso-de-reanimacion-cardiopulmonar-rcp-y-dea-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [724, 725],
        multiple_languages: false,
    },
    // Curso de Reanimación Cardiopulmonar (RCP) y DEA - Idiomas
    {
        id: 724,
        tax: 0.0,
        sku: "iopos.course.online.curso-reanimacion-cardiopulmonar-rcp-y-dea-2026-es",
        title: "Curso de Reanimación Cardiopulmonar (RCP) y DEA",
        name: "Curso de Reanimación Cardiopulmonar (RCP) y DEA",
        short: "1.) Reanimación Cardiopulmonar (RCP) y DEA",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Aprende técnicas fundamentales para salvar vidas en situaciones de paro cardiorrespiratorio. Uso correcto del Desfibrilador Externo Automático (DEA) según protocolos internacionales.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/723/image3"],
        banner: ["/723/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-reanimacion-cardiopulmonar-rcp-y-dea-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 723,
        default_in_parent: true,
        evolmind: { course_id: 555, group_id: [2244] },
    },
    // Curs de Reanimació Cardiopulmonar (RCP) i DEA - Idiomes
    {
        id: 725,
        tax: 0.0,
        sku: "iopos.course.online.curso-reanimacion-cardiopulmonar-rcp-y-dea-2026-ca",
        title: "Curs de Reanimació Cardiopulmonar (RCP) i DEA",
        name: "Curs de Reanimació Cardiopulmonar (RCP) i DEA",
        short: "1.) Reanimació Cardiopulmonar (RCP) i DEA",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "-",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/723/image3"],
        banner: ["/723/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-reanimacion-cardiopulmonar-rcp-y-dea-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 723,
        evolmind: { course_id: 558, group_id: [2247] },
    },
    // Curso de Control de Hemorragias: Bleeding Control
    {
        id: 726,
        tax: 0.0,
        sku: "iopos.course.online.curso-control-de-hemorragias-bleeding-control-2026",
        title: "Curso de Control de Hemorragias: Bleeding Control",
        name: "Curso de Control de Hemorragias: Bleeding Control",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formación especializada en el control inmediato de hemorragias graves. Uso de torniquetes, vendajes compresivos y medidas de contención eficaces.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/726/image3"],
        banner: ["/726/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-control-de-hemorragias-bleeding-control-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [727, 728],
        multiple_languages: false,
    },
    // Curso de Control de Hemorragias: Bleeding Control - Idiomas
    {
        id: 727,
        tax: 0.0,
        sku: "iopos.course.online.control-de-hemorragis-bleeding-control-es",
        title: "Curso de Control de Hemorragias: Bleeding Control",
        name: "Curso de Control de Hemorragias: Bleeding Control",
        short: "1.) Control de Hemorragias: Bleeding Control",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "-",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/726/image3"],
        banner: ["/726/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-control-de-hemorragias-bleeding-control-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 726,
        default_in_parent: true,
        evolmind: { course_id: 561, group_id: [2250] },
    },
    // Curs de Control d'Hemorràgies: Bleeding Control - Idiomes
    {
        id: 728,
        tax: 0.0,
        sku: "iopos.course.online.control-de-hemorragis-bleeding-control-ca",
        title: "Curs de Control d'Hemorràgies: Bleeding Control",
        name: "Curs de Control d'Hemorràgies: Bleeding Control",
        short: "2.) Control d'Hemorràgies: Bleeding Control",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "-",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/726/image3"],
        banner: ["/726/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-control-de-hemorragias-bleeding-control-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 726,
        evolmind: { course_id: 564, group_id: [2253] },
    },
    // Curso de Manejo de Convulsiones
    {
        id: 729,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-de-convulsiones-2026",
        title: "Curs de Convulsions",
        name: "Curs de Convulsions",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per identificar i actuar amb seguretat, criteri i respecte davant de crisis convulsives en l’àmbit policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/729/image3"],
        banner: ["/729/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-manejo-de-convulsiones-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [730, 731],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070941",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Gestió de Convulsions",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a capacitar els **professionals** per **identificar** i **actuar** amb **seguretat**, **criteri** i **respecte** davant de crisis convulsives en l'àmbit policial.",
            landscape: "/729/hero_h",
            portrait: "/729/hero_v",
        },
    },
    // Curso de Manejo de Convulsiones - Idiomas
    {
        id: 730,
        tax: 0.0,
        sku: "iopos.course.online.curso-de-manejo-de-convulsiones-2026-es",
        title: "Curso de Manejo de Convulsiones",
        name: "Curso de Manejo de Convulsiones",
        short: "1.) Manejo de Convulsiones",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "-",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/729/image3"],
        banner: ["/729/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-manejo-de-convulsiones-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 729,
        default_in_parent: true,
        evolmind: { course_id: 567, group_id: [2256] },
    },
    // Curso de Manejo de Convulsiones - Idiomas
    {
        id: 731,
        tax: 0.0,
        sku: "iopos.course.online.curso-de-manejo-de-convulsiones-2026-ca",
        title: "Curs de Convulsions",
        name: "Curs de Convulsions",
        short: "1.) Convulsions",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per identificar i actuar amb seguretat, criteri i respecte davant de crisis convulsives en l’àmbit policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/729/image3"],
        banner: ["/729/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-gestion-de-convulsiones-2026/",
        created_at: "2025-05-12 00:00:01",
        start_at: "2025-05-12 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 729,
        evolmind: { course_id: 570, group_id: [2259] },
    },
    // Curso de Accidente Cerebrovascular e Hipertensión
    {
        id: 732,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidente-cerebrovascular-e-hipertension-2026",
        title: "Curs d'Accident Cerebrovascular i Hipertensió",
        name: "Curs d'Accident Cerebrovascular i Hipertensió",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a la detecció precoç, la prevenció i l’actuació policial davant situacions d’ictus i emergències associades a la hipertensió arterial",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/732/image3"],
        banner: ["/732/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-accidente-cerebrovascular-e-hipertension-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [733, 734],
        multiple_languages: false,
    },
    // Curso de Accidente Cerebrovascular e Hipertensión - Idiomas
    {
        id: 733,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidente-cerebrovascular-e-hipertension-2026-es",
        title: "Curso de Accidente Cerebrovascular e Hipertensión",
        name: "Curso de Accidente Cerebrovascular e Hipertensión",
        short: "1.) Accidente Cerebrovascular e Hipertensión",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formación especializada orientada a la detección precoz, la prevención y la actuación policial ante situaciones de ictus y emergencias asociadas a la hipertensión arterial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/732/image3"],
        banner: ["/732/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-acceidente-cerebrovascular-e-hipertension-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 732,
        default_in_parent: true,
        evolmind: { course_id: 573, group_id: [2262] },
    },
    // Curs d'Accident Cerebrovascular i Hipertensió - Idiomes
    {
        id: 734,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidente-cerebrovascular-e-hipertension-2026-ca",
        title: "Curs d'Accident Cerebrovascular i Hipertensió",
        name: "Curs d'Accident Cerebrovascular i Hipertensió",
        short: "1.) Accident Cerebrovascular i Hipertensió",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a la detecció precoç, la prevenció i l’actuació policial davant situacions d’ictus i emergències associades a la hipertensió arterial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/732/image1"],
        banner: ["/732/image1"],
        link: "/tienda/cursos/formacion-policial/curso-de-acceidente-cerebrovascular-e-hipertension-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 732,
        evolmind: { course_id: 576, group_id: [2265] },
    },
    // Curso de Desobstrucción de la Vía Aérea
    {
        id: 735,
        tax: 0.0,
        sku: "iopos.course.online.curso-desobstruccion-de-la-via-aerea-2026",
        title: "Curs Desobstrucció de la Via Aèria",
        name: "Curs Desobstrucció de la Vía Aèria",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per reconèixer i actuar amb rapidesa i seguretat davant emergències per obstrucció de la via aèria en adults, infants i lactants.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/735/image3"],
        banner: ["/735/image3"],
        link: "/tienda/cursos/formacion-policial/curso-desobstruccion-de-la-via-aerea-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [736, 737],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070887",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Desobstrucció de la Via Aèria",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a capacitar els **professionals** per **reconèixer** i **actuar** amb **rapidesa** i **seguretat** davant **emergències** per obstrucció de la via aèria en adults, infants i lactants.",
            landscape: "/729/hero_h",
            portrait: "/729/hero_v",
        },
    },
    // Curso de Desobstrucción de la Vía Aérea - Idiomas
    {
        id: 736,
        tax: 0.0,
        sku: "iopos.course.online.curso-desobstruccion-de-la-via-aerea-2026-es",
        title: "Curso Desobstrucción de la Vía Aérea",
        name: "Curso Desobstrucción de la Vía Aérea",
        short: "1.) Desobstrucción de la Vía Aérea",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "-",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/735/image3"],
        banner: ["/735/image3"],
        link: "/tienda/cursos/formacion-policial/curso-desobstruccion-de-la-via-aerea-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 735,
        default_in_parent: true,
        evolmind: { course_id: 579, group_id: [2268] },
    },
    // Curs de Desobstrucció de la Via Aèria - Idiomes
    {
        id: 737,
        tax: 0.0,
        sku: "iopos.course.online.curso-desobstruccion-de-la-via-aerea-2026-ca",
        title: "Curs Desobstrucció de la Via Aèria",
        name: "Curs Desobstrucció de la Vía Aèria",
        short: "1.) Desobstrucció de la Via Aèria",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per reconèixer i actuar amb rapidesa i seguretat davant emergències per obstrucció de la via aèria en adults, infants i lactants.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/735/image3"],
        banner: ["/735/image3"],
        link: "/tienda/cursos/formacion-policial/curso-desobstruccion-de-la-via-aerea-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 735,
        evolmind: { course_id: 582, group_id: [2271] },
    },
    // Curso de Asistencia al Parto
    {
        id: 738,
        tax: 0.0,
        sku: "iopos.course.online.curso-de-asistencia-al-parto-2026",
        title: "Curs d'Assistència al Part",
        name: "Curso d'Assistència al Part",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per actuar amb seguretat, criteri i humanitat davant d’un part extrahospitalari fins a l’arribada dels serveis sanitaris.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/738/image3"],
        banner: ["/738/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-asistencia-al-parto-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [739, 740],
        multiple_languages: false,
    },
    // Curso de Asistencia al Parto - Idiomas
    {
        id: 739,
        tax: 0.0,
        sku: "iopos.course.online.curso-de-asistencia-al-parto-2026-es",
        title: "Curso de Asistencia al Parto",
        name: "Curso de Asistencia al Parto",
        short: "1.) Asistencia al Parto",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "-",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/738/image3"],
        banner: ["/738/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-asistencia-al-parto-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 738,
        default_in_parent: true,
        evolmind: { course_id: 585, group_id: [2274] },
    },
    // Curs d'Assistència al Part - Idiomes
    {
        id: 740,
        tax: 0.0,
        sku: "iopos.course.online.curso-de-asistencia-al-parto-2026-ca",
        title: "Curs d'Assistència al Part",
        name: "Curso d'Assistència al Part",
        short: "1.) Assistència al Part",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per actuar amb seguretat, criteri i humanitat davant d’un part extrahospitalari fins a l’arribada dels serveis sanitaris.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/738/image3"],
        banner: ["/738/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-asistencia-al-parto-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 738,
        evolmind: { course_id: 588, group_id: [2277] },
    },
    // Curso Manejo de Quemaduras
    {
        id: 741,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-de-quemaduras-2026",
        title: "Curs Maneig de Cremades",
        name: "Curs Maneig de Cremades",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per identificar, valorar i actuar amb criteri i seguretat davant persones amb cremades, com a primers intervinents",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/741/image3"],
        banner: ["/741/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-de-quemaduras-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [742, 743],
        multiple_languages: false,
    },
    // Curso Manejo de Quemaduras - Idiomas
    {
        id: 742,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-de-quemaduras-2026-es",
        title: "Curso Manejo de Quemaduras",
        name: "Curso Manejo de Quemaduras",
        short: "1.) Manejo de Quemaduras",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "-",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/741/image3"],
        banner: ["/741/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-asistencia-al-parto-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 741,
        default_in_parent: true,
        evolmind: { course_id: 591, group_id: [2280] },
    },
    // Curs Maneig de Cremades - Idiomes
    {
        id: 743,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-de-quemaduras-2026-es",
        title: "Curs Maneig de Cremades",
        name: "Curs Maneig de Cremades",
        short: "1.) Maneig de Cremades",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per identificar, valorar i actuar amb criteri i seguretat davant persones amb cremades, com a primers intervinents",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/741/image3"],
        banner: ["/741/image3"],
        link: "/tienda/cursos/formacion-policial/-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 741,
        evolmind: { course_id: 597, group_id: [2283] },
    },
    // Curso Manejo Básico de la Vía Aérea
    {
        id: 744,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-basico-de-la-via-aerea-2026",
        title: "Curs Maneig Bàsic de la Via Aèria",
        name: "Curs Maneig Bàsic de la Via Aèria",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per garantir la permeabilitat de la via aèria i actuar amb criteri, rapidesa i seguretat davant situacions de compromís respiratori.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/744/image4"],
        banner: ["/744/image4"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-de-la-via-aerea-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [745, 746],
        multiple_languages: false,
    },
    // Curso Manejo Básico de la Vía Aérea - Idiomas
    {
        id: 745,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-basico-de-la-via-aerea-2026-es",
        title: "Curso Manejo Básico de la Vía Aérea",
        name: "Curso Manejo Básico de la Vía Aérea",
        short: "1.) Manejo Básico de la Vía Aérea",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "-",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/745/image4"],
        banner: ["/745/image4"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-basico-de-la-via-aerea-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 744,
        default_in_parent: true,
        evolmind: { course_id: 600, group_id: [2286] },
    },
    // Curs Maneig Bàsic de la Via Aèria - Idiomes
    {
        id: 746,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-basico-de-la-via-aerea-2026-ca",
        title: "Curs Maneig Bàsic de la Via Aèria",
        name: "Curs Maneig Bàsic de la Via Aèria",
        short: "1.) Maneig Bàsic de la Via Aèria",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per garantir la permeabilitat de la via aèria i actuar amb criteri, rapidesa i seguretat davant situacions de compromís respiratori.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/744/image4"],
        banner: ["/744/image4"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-basico-de-la-via-aerea-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 744,
        evolmind: { course_id: 603, group_id: [2289] },
    },
    // Curso Accidentes con Ofidios: Manejo de Picaduras y Mordeduras
    {
        id: 747,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidentes-con-ofidios-manejo-picaduras-y-mordeduras-2026",
        title: "Curso Accidentes con Ofidios: Manejo de Picaduras y Mordeduras",
        name: "Curso Accidentes con Ofidios: Manejo de Picaduras y Mordeduras",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Reconocimiento y actuación ante mordeduras de serpiente o picaduras tóxicas. Medidas de contención, traslado y primeros auxilios.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/747/image3"],
        banner: ["/747/image3"],
        link: "/tienda/cursos/formacion-policial/curso-accidentes-con-ofidios-manejo-de-picaduras-y-mordeduras-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [748, 749],
        multiple_languages: false,
    },
    // Curso Accidentes con Ofidios: Manejo de Picaduras y Mordeduras - Idiomas
    {
        id: 748,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidentes-con-ofidios-manejo-picaduras-y-mordeduras-2026-es",
        title: "Curso Accidentes con Ofidios: Manejo de Picaduras y Mordeduras",
        name: "Curso Accidentes con Ofidios: Manejo de Picaduras y Mordeduras",
        short: "1.) Manejo Básico de la Vía Aérea",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/747/image3"],
        banner: ["/747/image3"],
        link: "/tienda/cursos/formacion-policial/curso-accidentes-con-ofidios-manejo-de-picaduras-y-mordeduras-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 748,
        default_in_parent: true,
        evolmind: { course_id: 606, group_id: [2292] },
    },
    // Curs Accidents amb Ofidis: Maneig de Picades i Mossegades - Idiomes
    {
        id: 749,
        tax: 0.0,
        sku: "iopos.course.online.curso-accidentes-con-ofidios-manejo-picaduras-y-mordeduras-2026-ca",
        title: "Curs Accidents amb Ofidis: Maneig de Picades i Mossegades",
        name: "Curs Accidents amb Ofidis: Maneig de Picades i Mossegades",
        short: "2.) Accidents amb Ofidis: Maneig de Picades i Mossegades",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/747/image3"],
        banner: ["/747/image3"],
        link: "/tienda/cursos/formacion-policial/curso-accidentes-con-ofidios-manejo-de-picaduras-y-mordeduras-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 747,
        evolmind: { course_id: 609, group_id: [2295] },
    },
    // Curso Manejo y Abordaje Traumatismo Cráneoencefálico
    {
        id: 750,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-y-abordaje-traumatismo-craneoencefalico-2026",
        title: "Curso Manejo y Abordaje Traumatismo Cráneoencefálico",
        name: "Curso Manejo y Abordaje Traumatismo Cráneoencefálico",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Evaluación inicial y cuidados prioritarios en lesiones craneales. Actuación según nivel de conciencia y riesgo vital.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/750/image3"],
        banner: ["/750/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-y-aboraje-del-traumatismo-craneoencefalico-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [751, 752],
        multiple_languages: false,
    },
    // Curso Manejo y Abordaje Traumatismo Cráneoencefálico - Idiomas
    {
        id: 751,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-y-abordaje-traumatismo-craneoencefalico-2026-es",
        title: "Curso Manejo y Abordaje Traumatismo Cráneoencefálico",
        name: "Curso Manejo y Abordaje Traumatismo Cráneoencefálico",
        short: "1.) Manejo y Abordaje Traumatismo Cráneoencefálico",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/750/image3"],
        banner: ["/750/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-y-abordaje-traumatismo-craneoencefalico-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 750,
        default_in_parent: true,
        evolmind: { course_id: 612, group_id: [2298] },
    },
    // Curs Maneig i Enfrontament del Traumatisme Cráneoencefàlic - Idiomes
    {
        id: 752,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-y-abordaje-traumatismo-craneoencefalico-2026-ca",
        title: "Curs Maneig i Enfrontament del Traumatisme Cráneoencefàlic",
        name: "Curs Maneig i Enfrontament del Traumatisme Cráneoencefàlic",
        short: "2.) Maneig i Enfrontament del Traumatisme Cráneoencefàlic",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/750/image3"],
        banner: ["/750/image3"],
        link: "/tienda/cursos/formacion-policial/-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 750,
        evolmind: { course_id: 615, group_id: [2301] },
    },
    // Curso Emergencias Psiquiátricas
    {
        id: 753,
        tax: 0.0,
        sku: "iopos.course.online.curso-emergencias-psiquiatricas-2026",
        title: "Curs Emergències Psiquiàtriques",
        name: "Curs Emergències Psiquiàtriques",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a actuar amb criteri professional, seguretat jurídica i control operatiu davant situacions d’emergència psiquiàtrica en l’àmbit policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        // offer: 69.99,
        // offer_text: "¡Promo de llançament 2024!",
        shipment: 0.0,
        images: ["/753/image4"],
        banner: ["/753/image4"],
        link: "/tienda/cursos/formacion-policial/curso-emergencias-psiquiatricas-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [754, 755],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250070939",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de Emergències Psiquiàtriques",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **actuar** amb **criteri** **professional**, **seguretat jurídica** i **control operatiu** davant situacions d’**emergència psiquiàtrica** en l’àmbit policial.",
            landscape: "/753/hero_h",
            portrait: "/753/hero_v",
        },
    },
    // Curso Emergencias Psiquiátricas - ES
    {
        id: 754,
        tax: 0.0,
        sku: "iopos.course.online.curso-emergencias-psiquiatricas-2026-es",
        title: "Curso Emergencias Psiquiátricas",
        name: "Curso Emergencias Psiquiátricas",
        short: "1.) Emergencias Psiquiátricas",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "-",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/753/image4"],
        banner: ["/753/image4"],
        link: "/tienda/cursos/formacion-policial/curso-emergencias-psiquiatricas-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 753,
        default_in_parent: true,
        evolmind: { course_id: 618, group_id: [2304] },
    },
    // Curs Emergències Psiquiàtriques - CA
    {
        id: 755,
        tax: 0.0,
        sku: "iopos.course.online.curso-emergencias-psiquiatricas-2026-ca",
        title: "Curs Emergències Psiquiàtriques",
        name: "Curs Emergències Psiquiàtriques",
        short: "1.) Emergències Psiquiàtriques",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a actuar amb criteri professional, seguretat jurídica i control operatiu davant situacions d’emergència psiquiàtrica en l’àmbit policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/753/image4"],
        banner: ["/753/image4"],
        link: "/tienda/cursos/formacion-policial/curs-emergencies-psiquiatriques-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 753,
        evolmind: { course_id: 621, group_id: [2307] },
    },
    // Curso Actualización de las Herramientas en la Conducta Suicida
    {
        id: 756,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-herramientas-suicida-2026",
        title: "Curso Actualización de las Herramientas en la Conducta Suicida",
        name: "Curso Actualización de las Herramientas en la Conducta Suicida",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/756/image3"],
        banner: ["/756/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-de-las-herramientas-en-la-conducta-suicida-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [757, 758],
        multiple_languages: false,
    },
    // Curso Actualización de las Herramientas en la Conducta Suicida - Idiomas
    {
        id: 757,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-herramientas-suicida-2026-es",
        title: "Curso Actualización de las Herramientas en la Conducta Suicida",
        name: "Curso Actualización de las Herramientas en la Conducta Suicida",
        short: "1.) Actualización Herramientas Conducta Suicida",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/756/image3"],
        banner: ["/756/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-de-las-herramientas-en-la-conducta-suicida-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 757,
        default_in_parent: true,
        evolmind: { course_id: 636, group_id: [2322] },
    },
    // Curs Actualització de les Eines en la Conducta Suicida - Idiomes
    {
        id: 758,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-herramientas-suicida-2026-ca",
        title: "Curs Actualització de les Eines en la Conducta Suicida",
        name: "Curs Actualització de les Eines en la Conducta Suicida",
        short: "2.) Actualització Eines Conducta Suicida",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/756/image3"],
        banner: ["/756/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-de-las-herramientas-en-la-conducta-suicida-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 756,
        evolmind: { course_id: 639, group_id: [2325] },
    },
    // Curso Criterios de Inmovilización en el Trauma
    {
        id: 759,
        tax: 0.0,
        sku: "iopos.course.online.curso-criterios-de-inmovilizacion-trauma-2026",
        title: "Curs Criteris d'Immobilització en el Trauma",
        name: "Curs Criteris d'Immobilització en el Trauma",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a garantir una actuació policial segura i coordinada en la immobilització de víctimes traumàtiques, d’acord amb protocols mèdics actuals.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/759/image4"],
        banner: ["/759/image4"],
        link: "/tienda/cursos/formacion-policial/curso-criterios-de-inmobilizacion-en-el-trauma-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [760, 761],
        multiple_languages: false,
    },
    // Curso Criterios de Inmovilización en el Trauma - Idiomas
    {
        id: 760,
        tax: 0.0,
        sku: "iopos.course.online.curso-criterios-de-inmovilizacion-trauma-2026-es",
        title: "Curso Criterios de Inmovilización en el Trauma",
        name: "Curso Criterios de Inmovilización en el Trauma",
        short: "1.) Criterios de Inmovilización en el Trauma",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "-",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/759/image4"],
        banner: ["/759/image4"],
        link: "/tienda/cursos/formacion-policial/curso-criterios-de-inmovilizacion-en-el-trauma-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 759,
        default_in_parent: true,
        evolmind: { course_id: 642, group_id: [2328] },
    },
    // Curs Criteris d'Immobilització en el Trauma - Idiomes
    {
        id: 761,
        tax: 0.0,
        sku: "iopos.course.online.curso-criterios-de-inmovilizacion-trauma-2026-ca",
        title: "Curs Criteris d'Immobilització en el Trauma",
        name: "Curs Criteris d'Immobilització en el Trauma",
        short: "1.) Criteris d'Immobilització en el Trauma",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a garantir una actuació policial segura i coordinada en la immobilització de víctimes traumàtiques, d’acord amb protocols mèdics actuals.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/759/image4"],
        banner: ["/759/image4"],
        link: "/tienda/cursos/formacion-policial/curso-criterios-de-inmobilizacion-en-el-trauma-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 759,
        evolmind: { course_id: 645, group_id: [2331] },
    },
    // Curso Búsqueda y Rescate Aéreo en Zonas Agrestes
    {
        id: 762,
        tax: 0.0,
        sku: "iopos.course.online.curso-busqueda-y-rescate-aereo-zonas-agrestes-2026",
        title: "Curso Búsqueda y Rescate Aéreo en Zonas Agrestes",
        name: "Curso Búsqueda y Rescate Aéreo en Zonas Agrestes",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Planificación y ejecución de rescates en zonas rurales o de difícil acceso. Coordinación efectiva con medios aéreos.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/762/image3"],
        banner: ["/762/image3"],
        link: "/tienda/cursos/formacion-policial/curso-busqueda-y-rescate-aereo-en-zonas-agrestes-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [763, 764],
        multiple_languages: false,
    },
    // Curso Búsqueda y Rescate Aéreo en Zonas Agrestes - Idiomas
    {
        id: 763,
        tax: 0.0,
        sku: "iopos.course.online.curso-busqueda-y-rescate-aereo-zonas-agrestes-2026-es",
        title: "Curso Búsqueda y Rescate Aéreo en Zonas Agrestes",
        name: "Curso Búsqueda y Rescate Aéreo en Zonas Agrestes",
        short: "1.) Búsqueda y Rescate Aéreo en Zonas Agrestes",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/762/image3"],
        banner: ["/762/image3"],
        link: "/tienda/cursos/formacion-policial/curso-busquea-y-rescate-aereo-en-zonas-agrestes-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 762,
        default_in_parent: true,
        evolmind: { course_id: 648, group_id: [2334] },
    },
    // Curs Cerca i Rescat Aeri en Zones Agrestes - Idiomes
    {
        id: 764,
        tax: 0.0,
        sku: "iopos.course.online.curso-busqueda-y-rescate-aereo-zonas-agrestes-2026-ca",
        title: "Curs Cerca i Rescat Aeri en Zones Agrestes",
        name: "Curs Cerca i Rescat Aeri en Zones Agrestes",
        short: "2.) Cerca i Rescat Aeri en Zones Agrestes",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/762/image3"],
        banner: ["/762/image3"],
        link: "/tienda/cursos/formacion-policial/curso-busqueda-y-rescate-aereo-zonas-agrestes-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 762,
        evolmind: { course_id: 651, group_id: [2337] },
    },
    // Actualización en Soporte Vital Avanzado
    {
        id: 765,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-soporte-vital-avanzado-2026",
        title: "Curso Actualización en Soporte Vital Avanzado",
        name: "Curso Actualización en Soporte Vital Avanzado",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Revisión de protocolos internacionales en emergencias avanzadas. Aplicación de algoritmos y uso de dispositivos especializados.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/765/image3"],
        banner: ["/765/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-en-soporte-vital-avanzado-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [766, 767],
        multiple_languages: false,
    },
    // Curso Actualización en Soporte Vital Avanzado - Idiomas
    {
        id: 766,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-soporte-vital-avanzado-2026-es",
        title: "Curso Actualización en Soporte Vital Avanzado",
        name: "Curso Actualización en Soporte Vital Avanzado",
        short: "1.) Actualización en Soporte Vital Avanzado",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/765/image3"],
        banner: ["/765/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-soporte-vital-avanzado-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 765,
        default_in_parent: true,
        evolmind: { course_id: 654, group_id: [2340] },
    },
    // Curs Actualització en Suport Vital Avançat - Idiomes
    {
        id: 767,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-soporte-vital-avanzado-2026-ca",
        title: "Curs Actualització en Suport Vital Avançat",
        name: "Curs Actualització en Suport Vital Avançat",
        short: "2.) Actualització en Suport Vital Avançat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/765/image3"],
        banner: ["/765/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-soporte-vital-avanzado-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 765,
        evolmind: { course_id: 657, group_id: [2343] },
    },
    // Actuación y Actualización en Pruebas de DrogoAlcoholemia
    {
        id: 768,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-y-actualizacion-pruebas-drogoalcoholemia-2026",
        title: "Curs Actuació i Actualització en Proves de Drogoalcoholèmia",
        name: "Curs Actuació i Actualització en Proves de Drogoalcoholèmia",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació tècnica especialitzada orientada a garantir una actuació policial rigorosa, segura i jurídicament sòlida en la pràctica de proves d’alcoholèmia i detecció de drogues en la conducció.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/768/image3"],
        banner: ["/768/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-y-actualizacion-pruebas-drogoalcoholemia-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [769, 770],
        multiple_languages: false,
    },
    // 769. Curso Actuación y Actualización en Pruebas de DrogoAlcoholemia - Idiomas
    {
        id: 769,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-y-actualizacion-pruebas-drogoalcoholemia-2026-es",
        title: "Curso Actuación y Actualización en Pruebas de DrogoAlcoholemia",
        name: "Curso Actuación y Actualización en Pruebas de DrogoAlcoholemia",
        short: "1.) Actuación y Actualización en Pruebas de DrogoAlcoholemia",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/768/image3"],
        banner: ["/768/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-y-actualizacion-pruebas-de-alcoholemia-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 768,
        default_in_parent: true,
        evolmind: { course_id: 696, group_id: [2382] },
    },
    // Curs Actuació i Actualitzación en Proves de Drogoalcoholemia - Idiomes
    {
        id: 770,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-y-actualizacion-pruebas-drogoalcoholemia-2026-ca",
        title: "Curs Actuació i Actualització en Proves de Drogoalcoholèmia",
        name: "Curs Actuació i Actualització en Proves de Drogoalcoholèmia",
        short: "1.) Actuació i Actualització en Proves de Drogoalcoholèmia",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/769/image3"],
        banner: ["/769/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-y-actualizacion-pruebas-drogoalcoholemia-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 768,
        evolmind: { course_id: 699, group_id: [2385] },
    },
    // Control de Hemorragias
    {
        id: 771,
        tax: 0.0,
        sku: "iopos.course.online.curso-control-de-hemorragias-2026",
        title: "Curs en Control d'Hemorràgies",
        name: "Curs en Control d'Hemorràgies",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Formació especialitzada orientada a capacitar els professionals per identificar, prioritzar i controlar hemorràgies greus amb criteri operatiu i seguretat en l’àmbit policial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/771/image4"],
        banner: ["/771/image4"],
        link: "/tienda/cursos/formacion-policial/curso-en-control-de-hemorragias-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [772, 773],
        multiple_languages: false,
    },
    // Curso en Control de Hemorragias - Idiomas
    {
        id: 772,
        tax: 0.0,
        sku: "iopos.course.online.curso-curso-en-control-de-hemorragias-2026-es",
        title: "Curso en Control de Hemorragias",
        name: "Curso en Control de Hemorragias",
        short: "1.) Control de Hemorragias",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/771/image4"],
        banner: ["/771/image4"],
        link: "/tienda/cursos/formacion-policial/curso-en-control-de-hemorragias-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 771,
        default_in_parent: true,
        evolmind: { course_id: 660, group_id: [2346] },
    },
    // Curs en Control d'Hemorràgies - Idiomes
    {
        id: 773,
        tax: 0.0,
        sku: "iopos.course.online.curso-curso-en-control-de-hemorragias-2026-ca",
        title: "Curs en Control d'Hemorràgies",
        name: "Curs en Control d'Hemorràgies",
        short: "1.) Control d'Emorràgies",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/771/image4"],
        banner: ["/771/image4"],
        link: "/tienda/cursos/formacion-policial/curso--2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 771,
        evolmind: { course_id: 663, group_id: [2349] },
    },
    // Actualizaciones en Rescate Acuático
    {
        id: 774,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizaciones-en-rescate-acuatico-2026",
        title: "Curso Actualizaciones en Rescate Acuático",
        name: "Curso Actualizaciones en Rescate Acuático",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Intervención en ahogamientos y situaciones de emergencia en medios acuáticos. Técnicas de rescate, estabilización y traslado.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/774/image3"],
        banner: ["/774/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizaciones-en-rescate-acuatico-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [775, 776],
        multiple_languages: false,
    },
    // Curso Actualizaciones en Rescate Acuático - Idiomas
    {
        id: 775,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizaciones-en-rescate-acuatico-2026-es",
        title: "Curso Actualizaciones en Rescate Acuático",
        name: "Curso Actualizaciones en Rescate Acuático",
        short: "1.) Actualizaciones en Rescate Acuático",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/774/image3"],
        banner: ["/774/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizaciones-en-rescate-acuatico-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 774,
        default_in_parent: true,
        evolmind: { course_id: 666, group_id: [2352] },
    },
    // Curs Actualitzacions en Rescat Aquàtic - Idiomes
    {
        id: 776,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizaciones-en-rescate-acuatico-2026-ca",
        title: "Curs Actualitzacions en Rescat Aquàtic",
        name: "Curs Actualitzacions en Rescat Aquàtic",
        short: "2.) Actualitzacions en Rescat Aquàtic",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/774/image3"],
        banner: ["/774/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizaciones-en-rescate-acuatico-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 774,
        evolmind: { course_id: 669, group_id: [2355] },
    },
    // Manejo Seguro de Cadáveres en desastres
    {
        id: 777,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-seguro-de-cadaveres-en-desastres-2026",
        title: "Curso Manejo Seguro de Cadáveres en Desastres",
        name: "Curso Manejo Seguro de Cadáveres en Desastres",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Protocolos de identificación, preservación y traslado de cuerpos en catástrofes. Enfoque humanitario y sanitario.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/777/image3"],
        banner: ["/777/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-seguro-de-cadaveres-en-desastres-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [778, 779],
        multiple_languages: false,
    },
    // Curso Manejo Seguro de Cadáveres en desastres - Idiomas
    {
        id: 778,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-seguro-de-cadaveres-en-desastres-2026-es",
        title: "Curso Manejo Seguro de Cadáveres en Desastres",
        name: "Curso Manejo Seguro de Cadáveres en Desastres",
        short: "1.) Manejo Seguro de Cadáveres en Desastres",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/777/image3"],
        banner: ["/777/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-seguro-de-cadaveres-en-desastres-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 777,
        default_in_parent: true,
        evolmind: { course_id: 672, group_id: [2358] },
    },
    // Curs Gestió Segura de Cadàvers en Desastres - Idiomes
    {
        id: 779,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-seguro-de-cadaveres-en-desastres-2026-ca",
        title: "Curs Gestió Segura de Cadàvers en Desastres",
        name: "Curs Gestió Segura de Cadàvers en Desastres",
        short: "2.) Gestió Segura de Cadàvers en Desastres",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/777/image3"],
        banner: ["/777/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-seguro-de-cadaveres-en-desastres-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 777,
        evolmind: { course_id: 675, group_id: [2361] },
    },
    // Manejo Defensivo: Función del Chofer
    {
        id: 780,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-defensivo-funcion-del-chofer-2026",
        title: "Curso Manejo Defensivo: Función del Chofer",
        name: "Curso Manejo Defensivo: Función del Chofer",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Conducción segura y preventiva en situaciones de riesgo operativo. Técnicas para escoltas, patrullaje y traslados urgentes.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/780/image3"],
        banner: ["/780/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-defensivo-funcion-del-chofer-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [781, 782],
        multiple_languages: false,
    },
    // Curso Manejo Defensivo: Función del Chofer - Idiomas
    {
        id: 781,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-defensivo-funcion-del-chofer-2026-es",
        title: "Curso Manejo Defensivo: Función del Chofer",
        name: "Curso Manejo Defensivo: Función del Chofer",
        short: "1.) Manejo Defensivo: Función del Chofer",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/780/image3"],
        banner: ["/780/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-defensivo-funcion-del-chofer-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 780,
        default_in_parent: true,
        evolmind: { course_id: 678, group_id: [2364] },
    },
    // Curs Conducció Defensiva: Funció del Conductor - Idiomes
    {
        id: 782,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-defensivo-funcion-del-chofer-2026-ca",
        title: "Curs Conducció Defensiva: Funció del Conductor",
        name: "Curs Conducció Defensiva: Funció del Conductor",
        short: "1.) Conducció Defensiva: Funció del Conductor",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/780/image3"],
        banner: ["/780/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-defensivo-funcion-del-chofer-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 780,
        evolmind: { course_id: 681, group_id: [2367] },
    },
    // Rescate en Indencio y Esctructuras Colapsadas
    {
        id: 783,
        tax: 0.0,
        sku: "iopos.course.online.curso-rescate-en-incendio-y-estructuras-colapsadas-2026",
        title: "Curso Rescate en Incendio y Estructuras Colapsadas",
        name: "Curso Rescate en Incendio y Estructuras Colapsadas",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Intervención inicial en siniestros estructurales. Técnicas de búsqueda, evacuación y asistencia a víctimas atrapadas.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/783/image3"],
        banner: ["/783/image3"],
        link: "/tienda/cursos/formacion-policial/curso-rescate-en-incendio-y-estructuras-colapsadas-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [784, 785],
        multiple_languages: false,
    },
    // Curso Rescate en Incendio y Esctructuras Colapsadas - Idiomas
    {
        id: 784,
        tax: 0.0,
        sku: "iopos.course.online.curso-rescate-en-incendio-y-estructuras-colapsadas-2026-es",
        title: "Curso Rescate en Incendio y Estructuras Colapsadas",
        name: "Curso Rescate en Incendio y Estructuras Colapsadas",
        short: "1.) Rescate en Incendio y Estructuras Colapsadas",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/783/image3"],
        banner: ["/783/image3"],
        link: "/tienda/cursos/formacion-policial/curso-rescate-en-indencio-y-estructuras-colapsadas-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 783,
        default_in_parent: true,
        evolmind: { course_id: 684, group_id: [2370] },
    },
    // Curs Rescat en Incendi i Estructures Col·lapsades - Idiomes
    {
        id: 785,
        tax: 0.0,
        sku: "iopos.course.online.curso-rescate-en-incendio-y-estructuras-colapsadas-2026-es",
        title: "Curs Rescat en Incendi i Estructures Col·lapsades",
        name: "Curs Rescat en Incendi i Estructures Col·lapsades",
        short: "2.) Rescat en Incendi i Estructures Col·lapsades",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/783/image3"],
        banner: ["/783/image3"],
        link: "/tienda/cursos/formacion-policial/curso-rescate-en-incendio-y-estructuras-colapsadas-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 783,
        evolmind: { course_id: 687, group_id: [2373] },
    },
];
exports.default = products;
